import {ChangeDetectorRef, Component, Input} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "woa-text-field",
    templateUrl: "./text-field.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: TextFieldComponent, multi: true}]
})
export class TextFieldComponent extends AbstractField {
    @Input() type: "text" | "url" = "text";
    @Input() inputMode: "text" | "numeric" = "text";
    @Input() autocomplete: "username" | "given-name" | "family-name" | "street-address" | "address-level2" | "address-level1" | "postal-code" | "new-password";
    @Input() maxlength: string;
    @Input() spellcheck: boolean = true;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/text-field/text-field.component.ts